/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LuogoResDto } from '../../models/luogo-res-dto';

export interface LuoghiControllerFindLuogoEsteso$Params {
  /**
   * Search query for places, must be at least 3 characters long
   */
  q: string;

  /**
   * Filter by active status (0 = inactive, 1 = active)
   */
  flagAttivo?: number;
}

export function luoghiControllerFindLuogoEsteso(
  http: HttpClient,
  rootUrl: string,
  params: LuoghiControllerFindLuogoEsteso$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<LuogoResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    luoghiControllerFindLuogoEsteso.PATH,
    'get',
  );
  if (params) {
    rb.query('q', params.q, {});
    rb.query('flagAttivo', params.flagAttivo, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LuogoResDto>>;
      }),
    );
}

luoghiControllerFindLuogoEsteso.PATH = '/luoghi/cerca-esteso';
